// Lucee's onCFCRequest/serializeJSON uppercases every struct key on the wire, no matter how the
// CFML source cased it - same issue event-page's own data/keyMap.ts works around, scoped here to
// eventsList.cfc's own response shape.
const KEY_MAP: Record<string, string> = {
  SUCCESS: 'success',
  ERROR: 'error',
  VIEWER: 'viewer',
  YOUREVENT: 'yourEvent',
  FEATURED: 'featured',
  RACETIME: 'raceTime',
  MONTHS: 'months',
  FILTERS: 'filters',
  TOTALCOUNT: 'totalCount',

  LOGGEDIN: 'loggedIn',
  TYPE: 'type',
  TRACKID: 'trackId',
  FIRSTNAME: 'firstName',
  LASTNAME: 'lastName',
  TEAMMANAGER: 'teamManager',
  STRIPEMERCHANTID: 'stripeMerchantId',
  PROFILEPICURL: 'profilePicUrl',

  ID: 'id',
  NAME: 'name',
  TRACKNAME: 'trackName',
  CITY: 'city',
  STATE: 'state',
  STARTDT: 'startDT',
  ENDDT: 'endDT',
  FLYERURL: 'flyerUrl',
  RACETYPE: 'raceType',
  VEHICLETYPE: 'vehicleType',
  SERIESNAME: 'seriesName',
  SIGNUPWINDOWOPEN: 'signupWindowOpen',
  FULL: 'full',
  OPENPAYMENTDT: 'openPaymentDT',
  CLOSEPAYMENTDT: 'closePaymentDT',
  ENTRYLIMIT: 'entryLimit',
  ENTRYCOUNT: 'entryCount',
  RACERLIMIT: 'racerLimit',
  RACERCOUNT: 'racerCount',
  CLASSCOUNT: 'classCount',
  ENTEREDCLASSCOUNT: 'enteredClassCount',
  ENTEREDPAID: 'enteredPaid',
  DISTANCEMI: 'distanceMi',
  PRICEFROM: 'priceFrom',

  COUNT: 'count',
  EVENTS: 'events',

  REGISTRATION: 'registration',
  VALUE: 'value',
  LABEL: 'label',
  SERIES: 'series',
}

function toCamelKey(key: string): string {
  return KEY_MAP[key.toUpperCase()] ?? key
}

/** Recursively remaps every object key in a parsed eventsList.cfc response to camelCase. */
export function camelizeResponse<T>(value: unknown): T {
  if (Array.isArray(value)) {
    return value.map((item) => camelizeResponse(item)) as T
  }
  if (value !== null && typeof value === 'object') {
    const out: Record<string, unknown> = {}
    for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
      out[toCamelKey(key)] = camelizeResponse(val)
    }
    return out as T
  }
  return value as T
}
